const carousels = document.querySelectorAll('.glider');
carousels.forEach((el, index) => {
    new Glider(el, {
        slidesToShow: 3,
        draggable: true,
        dots: document.querySelectorAll('.dots')[index]
    });
});


const carouselsReviews = document.querySelectorAll('.review--container--carousel');
carouselsReviews.forEach((el) => {
    new Glider(el, {
        slidesToShow: 1.15,
        draggable: true,
        responsive: [
            {
                // screens greater than >= 775px
                breakpoint: 769,
                settings: {
                    slidesToShow: 4
                }
            }
        ]
    });
});

const carouselsBrands = document.querySelectorAll('.brand--carousel');
carouselsBrands.forEach((el, index) => {
    new Glider(el, {
        slidesToShow: 'auto',
        itemWidth: 90,
        exactWidth: true,
        slidesToScroll: 1,
        draggable: true,
        arrows: {
            prev: document.querySelectorAll('.brand--carousel--prev')[index],
            next: document.querySelectorAll('.brand--carousel--next')[index]
        },
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 8,
                    slidesToScroll: 8,
                    itemWidth: 100,
                    exactWidth: false,
                }
            }
        ]
    });
});

const carouselsOffer = document.querySelectorAll('.offer--carousel');
carouselsOffer.forEach((el, index) => {
    new Glider(el, {
        slidesToShow: 1.2,
        slidesToScroll: 1,
        dots: document.querySelectorAll('.offer--carousel--dots')[index],
        draggable: true,
        responsive: [
            {
                // screens greater than >= 775px
                breakpoint: 769,
                settings: {
                    slidesToShow: 4
                }
            }
        ]
    });
});


const modelPromoOffer = document.querySelectorAll('.model-promo--carousel');
modelPromoOffer.forEach((el, index) => {
    new Glider(el, {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: document.querySelectorAll('.model-promo--carousel--dots')[index],
        draggable: true
    });
});


const carouselsNews = document.querySelectorAll('.news--carousel');
carouselsNews.forEach((el) => {
    new Glider(el, {
        slidesToShow: 1.2,
        slidesToScroll: 1,
        draggable: true,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    });
});

const carouselsPromo = document.querySelectorAll('.promo--carousel');
carouselsPromo.forEach((el, index) => {
    new Glider(el, {
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: true,
        dots: document.querySelectorAll('.promo--carousel--dots')[index],
        responsive: [
            {
                // screens greater than >= 775px
                breakpoint: 769,
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    });
});


const carouselCar = document.querySelectorAll('.car-picture--carousel');
carouselCar.forEach((el, index) => {
    new Glider(el, {
        slidesToShow: 1,
        draggable: true,
        scrollLock: true,
        scrollLockDelay: 100,
        slidesToScroll: 1,
        dots: document.querySelectorAll('.car-picture--carousel--dots')[index],
        arrows: {
            prev: document.querySelectorAll('.car--carousel--gallery--arrows--prev')[index],
            next: document.querySelectorAll('.car--carousel--gallery--arrows--next')[index]
        }
    });
});

const carouselCarGallery = document.querySelectorAll('.car--carousel--gallery > div');
carouselCarGallery.forEach((el, index) => {
    new Glider(el, {
        slidesToShow: 1,
        draggable: true,
        scrollLockDelay: 100,
        scrollLock: true,
        slidesToScroll: 1,
        dots: document.querySelectorAll('.car--carousel--gallery--dots')[index],
        arrows: {
            prev: document.querySelectorAll('.car--carousel--gallery--arrows--prev')[index],
            next: document.querySelectorAll('.car--carousel--gallery--arrows--next')[index]
        }
    });

});

const carouselTileCar = document.querySelectorAll('.car-tile--carousel');
carouselTileCar.forEach((el, index) => {
    new Glider(el, {
        slidesToShow: 1,
        draggable: true,
        slidesToScroll: 1,
        dots: document.querySelectorAll('.car-tile--carousel--dots')[index]
    });
});

const carouselVariation = document.querySelectorAll('.car-picture--carousel');
carouselVariation.forEach((el, index) => {
    new Glider(el, {
        slidesToShow: 1,
        draggable: true,
        scrollLockDelay: 100,
        scrollLock: true,
        slidesToScroll: 1,
        dots: document.querySelectorAll('.car-picture--carousel--dots')[index],
        arrows: {
            prev: '.car--carousel--gallery--arrows--prev',
            next: '.car--carousel--gallery--arrows--next'
        }
    });
});

const carouselsMedia = document.querySelectorAll('.media--carousel');
carouselsMedia.forEach((el, index) => {
    if (!el.classList.contains('initialized')) {
        new Glider(el, {
            slidesToShow: 1,
            draggable: true,
            dots: document.querySelectorAll('.media--carousel--carousel--dots')[index]
        });
        let videoOverlays = el.querySelectorAll('.glider-slide .slide-video .video-container--overlay');
        videoOverlays.forEach((vid) => {
            vid.addEventListener('click', function (e) {
                e.preventDefault();
                vid.parentElement.classList.add('hidden');
                const $video = el.querySelector('video');
                if($video){
                    $video.play && $video.play();
                }
            })
        });

        el.classList.add('initialized');
    }
});
